<template>
  <div>
    <Create-agent
      :show="modifyPopup"
      :party="partyId"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </Create-agent>
    <div class="vx-card">
      <div class="vx-card__body">
        <div class="flex w-full justify-end">
          <filter-button @click="toggleShowFilters" />
        </div>
        <div
          class="vx-row flex flex-wrap gap-3 px-4 items-end"
          v-if="showFilters"
        >
          <div class="flex-grow" style="min-width: 250px">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{ $t("Name") }}</label>
              <vs-input
                v-model="gridSearchData.name"
                @keyup.enter="submitFilter"
                v-trim-space
              />
            </div>
          </div>
          <div class="flex-grow" style="min-width: 250px">
            <label class="vs-input--label">{{ $t("PartyType") }}</label>
            <div class="w-full">
              <v-select
                label="name"
                :options="PartyTypes"
                v-model="gridSearchData.partyTypeQuery"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="partySelected"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
          <div class="flex-grow" style="min-width: 250px">
            <label class="vs-input--label">{{ $t("CustomerAgentType") }}</label>
            <div class="w-full">
              <v-select
                label="name"
                :options="CustomerAgentTypes"
                v-model="gridSearchData.customerAgentTypeQuery"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="customerAgentSelected"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
          <div
            class="flex-grow flex gap-4 justify-end"
            style="min-width: 250px"
          >
            <vs-button
              type="filled"
              class="float-right"
              color="#3ec9d6"
              @click.prevent="resetForm"
              >{{ $t("ResetFilter") }}</vs-button
            >
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitFilter"
              >{{ $t("SubmitFilter") }}</vs-button
            >
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('ID') },
                { title: $t('OwnerID') },
                {
                  title: $t('SocialSecurityNumber'),
                  sort: 'SocialSecurityNumber',
                },
                { title: $t('CompanyNationalId'), sort: 'CompanyNationalId' },
                { title: $t('EconomicCode'), sort: 'EconomicCode' },
                { title: $t('PartyType'), sort: 'PartyType' },
                { title: $t('Customer'), sort: 'Customer' },
                { title: $t('Agent'), sort: 'IsAgent' },
                { title: $t('SalesAssistant') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 13%">
                  {{ row.name }}
                </td>
                <td style="width: 10%">
                  {{ row.id }}
                </td>
                <td style="width: 6%">
                  {{ row.ownerId }}
                </td>
                <td style="width: 12%">
                  <span v-if="row.socialSecurityNumber">
                    {{ row.socialSecurityNumber }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td style="width: 12%">
                  <span v-if="row.companyNationalId">
                    {{ row.companyNationalId }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td style="width: 12%; direction: ltr">
                  <span v-if="row.economicCode">{{ row.economicCode }}</span>
                  <span v-else>-</span>
                </td>
                <td style="width: 10%; direction: ltr">
                  <span v-if="row.partyType == 'Individual'">
                    {{ $t("Individual") }}
                  </span>
                  <span v-if="row.partyType == 'Legal'">
                    {{ $t("Legal") }}
                  </span>
                </td>
                <td style="width: 4%; direction: ltr">
                  <vs-checkbox
                    v-model="row.isCustomer"
                    :disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 4%; direction: ltr">
                  <vs-checkbox
                    v-model="row.isAgent"
                    :disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 6%; direction: ltr">
                  <vs-checkbox
                    v-model="row.isPromoter"
                    :disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 10%">
                  <vs-button
                    v-if="!row.isAgent"
                    class="bg_l_green"
                    @click.prevent="createAgent(row)"
                  >
                    <span> {{ $t("CreateAgent") }} </span>

                    <span v-if="row.partyType == 'Individual'">
                      {{ $t("Individual") }}
                    </span>
                    <span v-if="row.partyType == 'Legal'">
                      {{ $t("Legal") }}
                    </span>
                  </vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import vSelect from "vue-select";
import DataGrid from "@/components/datagrid/DataGrid";
import FilterButton from "@/components/buttons/FilterButton.vue";
import CreateAgent  from "./CreateAgent.vue";

export default {
  data() {
    return {
      showFilters: false,
      modifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/PartiesQuery",
      },
      partyId:-1,
      gridSearchData: {},
      CustomerAgentTypes: [
        { name: "مشتری ", id: 1 },
        { name: "نماینده", id: 2 },
        { name: "همیار فروش", id: 3 },
      ],
      PartyTypes: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    FilterButton,
    CreateAgent,
  },
  methods: {
    ...mapActions({
      createAgentFromCustomer: "individual/createAgentFromCustomer",
    }),
    createAgent(model) {
      if (model.partyType == "Individual") {
        this.modalModel = { partyId: model.id };
        this.$swal({
            title: "آیا از ایجاد نماینده اطمینان دارید؟",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "بلی",
            cancelButtonText: "خیر"
          }).then(result => {
            if (result.value) {
              this.createAgentFromCustomer(this.modalModel)
          .then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$refs.grid.renderGrid();
            });
            this.$validator.reset();
          })
          .catch(() => {
            this.disabled = false;
          });
            }
          });

      } else if (model.partyType == "Legal") {
        this.partyId=model.id
        this.modifyPopup = true;

      }
    },
    closeModifyPopup() {
      this.modifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    submitFilter() {
      if (this.gridSearchData.partyTypeQuery != null) {
        this.gridSearchData = {
          ...this.gridSearchData,
          partyTypeQuery: this.gridSearchData.partyTypeQuery,
        };
      }
      if (this.gridSearchData.customerAgentTypeQuery != null) {
        this.gridSearchData = {
          ...this.gridSearchData,
          customerAgentTypeQuery: this.gridSearchData.customerAgentTypeQuery,
        };
      }
      if (this.gridSearchData.name != null) {
        this.gridSearchData = {
          ...this.gridSearchData,
          name: this.gridSearchData.name,
        };
      }
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    resetForm() {
      this.gridSearchData = {
        keyword: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
        this.$refs.partySelected.clearSelection();
        this.$refs.customerAgentSelected.clearSelection();
      }, 0);
    },
  },
};
</script>
